import { ColumnsType } from "antd/lib/table/interface";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import ViewIcon from "@static/core/icons/icon-view.svg?react";
import { File } from "@/type/core/dashboard/dashboard.types";
import i18n from "i18next";
import BasicLink from "@components/core/links/BasicLink";
import { getToken } from "@utils/helpers/api.helper";
import ReplaceColumn from "@views/core/extranet/transactions/signature/columns/ReplaceColumn";
import { RemoveTransactionFilePayload } from "@state/transactions/CurrentTransactionEvents";

export const columns = (
  files: File[],
  setFiles: (files: File[]) => void,
  removeFile: (payload: RemoveTransactionFilePayload) => void,
): ColumnsType<File> => [
  {
    key: "sort",
    width: 38,
    className: "text-center",
  },
  {
    dataIndex: "name",
  },
  {
    dataIndex: "path",
    width: 44,
    className: "text-center",
    render: (path: string) => {
      const viewUrl = path + "?token=" + getToken();
      return path ? (
        <BasicLink
          target="_blank"
          to={viewUrl + "&download=false"}
          title={i18n.t("buttons.open")}
        >
          <ViewIcon className="icon-30 cursor-pointer" />
        </BasicLink>
      ) : (
        <></>
      );
    },
  },
  {
    dataIndex: "key",
    width: 44,
    className: "text-center",
    render: (key: string) => (
      <ReplaceColumn keyId={key} files={files} setFiles={setFiles} />
    ),
  },
  {
    dataIndex: "key",
    width: 44,
    className: "text-center",
    render: (key: string) => {
      return (
        <DeleteIcon
          className="icon-30 cursor-pointer"
          onClick={(ev) => {
            ev.preventDefault();
            removeFile({ key });
          }}
        />
      );
    },
  },
];
